import { render, staticRenderFns } from "./CustomTag.vue?vue&type=template&id=690b26fb&scoped=true&"
import script from "./CustomTag.vue?vue&type=script&lang=js&"
export * from "./CustomTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b26fb",
  null
  
)

export default component.exports